import { STATUS } from '@core/consts';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment-timezone';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var EquipmentMaintenanceMapperService = /** @class */ (function () {
    function EquipmentMaintenanceMapperService(translateService) {
        this.translateService = translateService;
        this.STATUS = STATUS;
    }
    EquipmentMaintenanceMapperService.prototype.toEquipmentMaintenancesMapped = function (maintenances) {
        var _this = this;
        var maintenancesMapped = [];
        maintenances.forEach(function (maintenance) {
            var status = STATUS.find(function (maintenanceStatus) { return maintenanceStatus.name === maintenance.status; });
            var maintenanceMapped = {
                id: maintenance.id,
                log: maintenance.logs[0] || null,
                status: maintenance.status,
                icon: status.icon,
                isCreated: true,
                eventDescription: {
                    location: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.LOCATION', { locationName: maintenance.location.name }),
                    segment: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.SEGMENT', {
                        segmentName: maintenance.segment.name
                    }),
                    maintenanceType: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.MAINTENANCE_TYPE', { maintenanceTypeName: maintenance.maintenanceType.name }),
                    company: maintenance.company ? _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.COMPANY', {
                        companyName: maintenance.company.name
                    }) : _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.WITHOUT_COMPANY')
                },
                eventName: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.MAINTENANCE_TITLE', {
                    maintenanceNumber: maintenance.number
                }) + (" - <span><b>" + _this.translateService.instant(status.translation) + "</b></span>"),
                colorClass: status.name,
                formattedCreatedAt: moment(maintenance.openedAt).local().format('DD/MM/YYYY'),
                createdAt: moment(maintenance.openedAt).local().format('DD/MM/YYYY HH:mm:ss'),
                showMessage: true
            };
            maintenancesMapped.push(maintenanceMapped);
        });
        return maintenancesMapped;
    };
    EquipmentMaintenanceMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentMaintenanceMapperService_Factory() { return new EquipmentMaintenanceMapperService(i0.ɵɵinject(i1.TranslateService)); }, token: EquipmentMaintenanceMapperService, providedIn: "root" });
    return EquipmentMaintenanceMapperService;
}());
export { EquipmentMaintenanceMapperService };
